import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";

const ShippingPolicy = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div
      className="shipping-policy-page py-5"
      style={{
        background: "linear-gradient(135deg, #f0fff4, #e6ffe6)",
        minHeight: "100vh",
      }}
    >
      <div className="container">
        <div className="text-center mb-5" data-aos="fade-down">
          <h1 className="fw-bold text-success">Shipping Policy</h1>
          <p className="text-muted">
            At <span className="fw-bold text-dark">RoupanNaturals</span>, we aim to deliver your products in the
            fastest and safest way possible.
          </p>
        </div>

        <div className="card shadow-lg border-0 rounded-4 p-4" data-aos="fade-up">
          <div className="card-body">
            <h4 className="fw-bold text-success mb-3">1. Shipping Locations</h4>
            <p>
              We currently ship across all major cities and towns in India. International
              shipping is not available at the moment.
            </p>

            <h4 className="fw-bold text-success mt-4 mb-3">2. Processing Time</h4>
            <p>
              Orders are usually processed within <b>1-2 business days</b>. Orders placed
              on weekends or holidays will be processed on the next working day.
            </p>

            <h4 className="fw-bold text-success mt-4 mb-3">3. Delivery Time</h4>
            <p>
              Delivery timelines may vary depending on your location:
              <ul>
                <li><b>Metro Cities:</b> 3-5 business days</li>
                <li><b>Other Cities:</b> 5-7 business days</li>
                <li><b>Remote Areas:</b> 7-10 business days</li>
              </ul>
            </p>

            <h4 className="fw-bold text-success mt-4 mb-3">4. Shipping Charges</h4>
            <p>
              We offer <b>Free Shipping</b> on all orders above ₹499. A flat shipping fee
              of ₹50 will be charged for orders below ₹499.
            </p>

            <h4 className="fw-bold text-success mt-4 mb-3">5. Order Tracking</h4>
            <p>
              Once your order is dispatched, you will receive an email/SMS with the
              tracking details. You can track your package in real-time.
            </p>

            <h4 className="fw-bold text-success mt-4 mb-3">6. Delayed Deliveries</h4>
            <p>
              While we make every effort to deliver your orders on time, unforeseen
              delays may occur due to weather, strikes, or courier issues. We appreciate
              your patience in such cases.
            </p>

            <h4 className="fw-bold text-success mt-4 mb-3">7. Contact Us</h4>
            <p>
              For any shipping-related queries, please reach out to us at <br />
              <b>Email:</b> roupannaturals@gmail.com <br />
              <b>Phone:</b> +91 8700723140
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
